module.exports = __webpack_public_path__ + "dbe4159c013e58d21d82eb254e27806c.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/graphics/woo-graphic.png
// module id = 773
// module chunks = 0